import { initializeApp } from "firebase/app";
import domtoimage from "dom-to-image";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  doc,
  addDoc,
  arrayUnion,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC7NbVmS6g7dWrCABa8mI_uWIb8XgXPIyU",
  authDomain: "lostanimal-7ca22.firebaseapp.com",
  databaseURL: "https://lostanimal-7ca22-default-rtdb.firebaseio.com",
  projectId: "lostanimal-7ca22",
  storageBucket: "lostanimal-7ca22.appspot.com",
  messagingSenderId: "118592522460",
  appId: "1:118592522460:web:93b674f1e36d5a72b08c19",
  measurementId: "G-EYPS7Z0TNX",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

//-------------------- Firebase functions -------------------- //

//GET general
export const getAllData = async (col) => {
  const queryCol = query(collection(db, col));
  try {
    const querySnapshot = await getDocs(queryCol);
    const queryData = querySnapshot.docs.map((doc) => {
      const data = doc.data();
      const id = doc.id;
      return { id, ...data };
    });
    return queryData;
  } catch (error) {
    console.error("Error al obtener datos:", error);
    throw error;
  }
};

// De esta forma me guarda la data y tambien el ID del DOC *crying*
// PROFILE: Get user by userid
export const getSingleUserData = async (currentUser) => {
  const queryUser = query(
    collection(db, "users"),
    where("userid", "==", currentUser.uid)
  );
  const querySnapshot = await getDocs(queryUser);
  const userData = querySnapshot.docs.map((doc) => {
    const data = doc.data();
    const id = doc.id;
    return { id, ...data };
  });
  return userData;
};

// PUBLISH PETS: Get pets by userid
export const getPetsByUserId = async (currentUser) => {
  const queryUser = query(
    collection(db, "mascota"),
    where("userId", "==", currentUser.uid)
  );
  const querySnapshot = await getDocs(queryUser);
  const petData = querySnapshot.docs.map((doc) => {
    const data = doc.data();
    const id = doc.id;
    return { id, ...data };
  });
  return petData;
};

// Funcion para calcular la distancia entre 2 puntos de una esfera

const haversineDistance = (lat1, lon1, lat2, lon2) => {
  const toRad = (value) => (value * Math.PI) / 180;
  const R = 6371; // Radio de la Tierra en km

  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) *
    Math.cos(toRad(lat2)) *
    Math.sin(dLon / 2) *
    Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c; // Distancia en km
};

// FILTERS

export const getPetById = async (id) => {
  const q = query(collection(db, "mascota"), where("__name__", "==", id));

  try {
    const data = await getDocs(q);
    const pData = data.docs.map((doc) => {
      const data = doc.data();
      const id = doc.id;
      return { id, ...data };
    });
    return pData;
  } catch (error) {
    console.error("Error getting document:", error);
    throw error;
  }
};

// FILTERS

const convertDateFormat = (dateStr) => {
  if (!dateStr) return "";
  const [day, month, year] = dateStr.split("/");
  return `${year}-${month}-${day}`;
};

export const getFilteredPets = async (
  filtros,
  radio,
  catEdad,
  fechaInicio,
  fechaFin
) => {
  const edadRango = filtros[catEdad] || {};
  // NO filtrar por fecha en la query, solo por los otros campos
  const queryFilters = query(
    collection(db, "mascota"),
    ...(filtros.sexo ? [where("sexo", "==", parseInt(filtros.sexo))] : []),
    ...(filtros.raza ? [where("raza", "==", parseInt(filtros.raza))] : []),
    ...(filtros.tipo ? [where("tipo", "==", parseInt(filtros.tipo))] : []),
    ...(filtros.tamano
      ? [where("tamano", "==", parseInt(filtros.tamano))]
      : []),
    ...(filtros.color ? [where("color", "==", parseInt(filtros.color))] : []),
    ...(filtros.estado
      ? [where("estado", "==", parseInt(filtros.estado))]
      : [])
    // NO agregues el filtro de fecha aquí
  );

  try {
    const querySnapshot = await getDocs(queryFilters);
    const petData = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // Filtrar por rango de edad después de convertir a número
    const filteredByAge = petData.filter((pet) => {
      const edadNum = Number(pet.edad);
      return (
        (edadRango.min === undefined || edadNum >= edadRango.min) &&
        (edadRango.max === undefined || edadNum <= edadRango.max)
      );
    });

    // Filtrar por fecha perdida (frontend)
    const filteredByDate = filteredByAge.filter((pet) => {
      if (!fechaInicio || !fechaFin) return true;
      // pet.fecha_perdido: "17/11/2025"
      // fechaInicio/fechaFin: "YYYY-MM-DD"
      const petDate = convertDateFormat(pet.fecha_perdido); // "2025-11-17"
      return petDate >= fechaInicio && petDate <= fechaFin;
    });

    // Filtrar por ubicación solo si lat y lng son distintos de ""
    const { lat, lng } = filtros;
    const filteredPets = filteredByDate.filter((pet) => {
      const petLat = pet.lat;
      const petLng = pet.lng;

      if (lat === "" || lng === "") {
        return true;
      }

      const distance = haversineDistance(lat, lng, petLat, petLng);
      return distance <= radio / 1000;
    });

    return filteredPets;
  } catch (error) {
    console.error("Error al obtener datos de mascotas:", error);
    throw error;
  }
};

//Contador de mascotas encontradas
export const contFoundPets = async () => {
  const queryFilters = query(
    collection(db, "mascota"),
    where("estado", "==", "Encontrado")
  );

  try {
    const querySnapshot = await getDocs(queryFilters);
    const contPetFound = querySnapshot.docs.length;
    return contPetFound;
  } catch (error) {
    console.error("Error al obtener datos de las mascotas encontradas:", error);
    throw error;
  }
};

// PROFILE: Update by doc id para el profile del user
export const updateSingleDoc = async (docId, editedData) => {
  const colRefUpd = doc(db, "users", docId);

  await updateDoc(colRefUpd, {
    phone: editedData,
  });
};

// PROFILE: Add new user when auth
export const addNewUser = async (uid) => {
  const colRefAdd = collection(db, "users");
  await addDoc(colRefAdd, {
    userid: uid,
  });
};

// PETDETAILS: Update in contact boolean
export const updatePetContact = async (docId, userId) => {
  const colRefUpd = doc(db, "mascota", docId);
  await updateDoc(colRefUpd, {
    en_contacto: true,
    contact_users: arrayUnion(userId), // agrega el userId al array
  });
};

// PETDETAILS: Update state by owner when contact
export const updatePetStateByOwner = async (docId, state) => {
  const colRefUpd = doc(db, "mascota", docId);
  await updateDoc(colRefUpd, {
    estado: state,
    en_contacto: false,
  });
};

// PETDETAILS: Set en_contacto to false y limpia el arreglo de usuarios contactados
export const resetPetContact = async (docId) => {
  const colRefUpd = doc(db, "mascota", docId);
  await updateDoc(colRefUpd, {
    en_contacto: false,
    contact_users: [], // limpia el array
  });
};

export const updateSinglePet = async (id, newDataPet) => {
  const docRef = doc(db, "mascota", id);
  await updateDoc(docRef, newDataPet);
};

// COMPARTIRMASCOTA: Sube la petCard a la API
export const uploadPetCard = async (elementRef, nombreMascota) => {
  if (!elementRef || !elementRef.current) {
    console.error("El elemento no está disponible para capturar.");
    return;
  }

  try {
    const node = elementRef.current;
    const scale = 3;
    const width = node.offsetWidth;
    const height = node.offsetHeight;

    const dataUrl = await domtoimage.toPng(node, {
      width: width * scale,
      height: height * scale,
      style: {
        transform: `scale(${scale})`,
        transformOrigin: "top left",
        width: `${width}px`,
        height: `${height}px`,
      },
    });
    
    const response = await fetch(dataUrl);
    const blob = await response.blob();
    
    // 3. Crear archivo File con el nombre de la mascota
    const imageName = `${nombreMascota}.png`;
    const imageFile = new File([blob], imageName, {
      type: "image/png",
    });

    const formData = new FormData();
    formData.append("image", imageFile);

    // petición POST a la API
    const apiResponse = await fetch("https://lost-animal-backend-production.up.railway.app/api/upload", {
      method: "POST",
      body: formData,
    });

    if (apiResponse.ok) {
      console.log(`✅ Imagen de ${nombreMascota} subida correctamente 🐶`);
    } else {
      console.error(`❌ Hubo un error al subir la imagen de ${nombreMascota}.`);
    }
  } catch (error) {
    console.error(
      `⚠️ Error al procesar o subir la imagen de ${nombreMascota}:`,
      error
    );
  }
};

//-------------------- End firebase functions -------------------- //
